let post = [
    {
      postId: '00001',
      author : 'master',          
      context : ' 아가 선물로 흰 운동화를 받았는데, 사이즈가 안맞네요. \n 흰운동화를 원하긴 했는데, 해외에서 사온거라 교환이 어려워서요.. \n 좀 더 큰사이즈 흰운동화 있으신 분 교환 원합니다. \n 아가 브랜드 운동화만 교환 신청해주세요! ',      
      imgFile  : '/assets/img/baby/shoe_2.jpg',       
      itemId : '20240304-06-A2',     
      likeCnt: 20, 
      visibleYn : true,            
      writeDate : '2024-02-22', 
      updateDate : '2024-02-22'
    },
    {
      postId: '00002',
      author : 'userKim',          
      context : ' 취향이 바뀌었나봄. \n 12/31 오페라/뮤지컬 2인용 티켓 -> 연말 락 페스티벌 티켓 구함 \n #문화생활 #교양있는 데이트 \n 아이다 공연은 내한공연 마지막이라고 함.. 희귀템. \n 뮤지컬티켓은 자리 R석 이상이거나, 비싼공연 1인용도 상관없음!',      
      imgFile : '/assets/img/tickets/ticket_1.jpg',       
      itemId : '20240304-06-A3',     
      likeCnt: 11, 
      visibleYn : true,            
      writeDate : '2024-02-22', 
      updateDate : '2024-02-22'
    },
    {
      postId: '00003',
      author : 'master',          
      context : ' 무지개색깔 양말 할인하길래 귀여워서 20켤레 구매했는데 너무 많네요. \n 흰색이나 검정색 양말 교환하실 분 찾습니다. \n 퀄리티 좋은 양말이면 숫자 더 많이 넣어 교환 해드려요. \n 댓글주세요!',      
      imgFile : '/assets/img/baby/shoe_3.jpg',       
      itemId : '20240304-06-A3',     
      likeCnt: 10, 
      visibleYn : true,            
      writeDate : '2024-02-22', 
      updateDate : '2024-02-22'
    },
    {
      postId: '00004',
      author : 'userKim',          
      context : '무지개색깔 양말 할인하길래 귀여워서 20켤레 구매했는데 너무 많네요. \n 흰색이나 검정색 양말 교환하실 분 찾습니다. \n 퀄리티 좋은 양말이면 숫자 더 많이 넣어 교환 해드려요. \n 댓글주세요!',      
      imgFile : '',       
      itemId : '',     
      likeCnt: 3, 
      visibleYn : true,            
      writeDate : '2024-02-22', 
      updateDate : '2024-02-22'
    },
    {
      postId: '00005',
      author : 'master',          
      context : '무지개색깔 양말 할인하길래 귀여워서 20켤레 구매했는데 너무 많네요. \n 흰색이나 검정색 양말 교환하실 분 찾습니다. \n 퀄리티 좋은 양말이면 숫자 더 많이 넣어 교환 해드려요. \n 댓글주세요!',      
      imgFile : '',       
      itemId : '',     
      likeCnt: 2, 
      visibleYn : true,            
      writeDate : '2024-02-22', 
      updateDate : '2024-02-22'
    },



  ];

  export default post;